import {
  getConversationBoardName,
  isExpertBoardConversation,
  resolveConversationMethodOrder,
} from '@/lib/conversation-methods';

export type MyConversationRow = {
  id: string;
  thinking_method_id: string | null;
  openai_conversation_id: string | null;
  updated_at: string | null;
  created_at: string | null;
};

export type ConversationLens = {
  id: string;
  name: string | null;
  author: string | null;
};

export type MyConversation = {
  id: string;
  kind: 'chat' | 'board';
  title: string;
  experts: string[];
  updatedAt: string | null;
  path: string;
};

export const conversationMethodIds = (rows: MyConversationRow[]): string[] =>
  [...new Set(rows.flatMap((row) =>
    resolveConversationMethodOrder(row.openai_conversation_id, row.thinking_method_id),
  ))];

export const describeMyConversation = (
  row: MyConversationRow,
  lenses: ReadonlyMap<string, ConversationLens>,
): MyConversation => {
  const methodIds = resolveConversationMethodOrder(row.openai_conversation_id, row.thinking_method_id);
  const isBoard = isExpertBoardConversation(row.openai_conversation_id);
  const primaryLens = methodIds.length ? lenses.get(methodIds[0]) : undefined;
  const experts = methodIds.map((id) => lenses.get(id)?.author?.trim() || 'Expert unavailable');

  return {
    id: row.id,
    kind: isBoard ? 'board' : 'chat',
    title: isBoard
      ? getConversationBoardName(row.openai_conversation_id) || 'Untitled Expert Board'
      : primaryLens?.name?.trim() || 'Lens conversation',
    experts,
    updatedAt: row.updated_at || row.created_at,
    path: `${isBoard ? '/board' : '/chat'}/${encodeURIComponent(row.id)}`,
  };
};
